import { generateMedia } from "styled-media-query"
import { defaultTheme } from "./theme"

export const customMedia = generateMedia(defaultTheme.breakpoints)
